import React, { useState, useEffect } from "react";
import axios from "axios";
import "../CSS/EnquiryForm.css";

const EnquiryForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    type: "",
    date: "",
  });
  const [enquiries, setEnquiries] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const resetForm = () => {
    setFormData({
      name: "",
      phone: "",
      type: "",
      date: "",
    });
    setEditingId(null);
  };

  useEffect(() => {
    fetchEnquiries();
  }, []);

  const fetchEnquiries = async () => {
    try {
      const response = await axios.get("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/getEnquiries");
      setEnquiries(
        Object.entries(response.data).map(([key, value], index) => ({
          ...value,
          key,
          sNo: index + 1,
        }))
      );
    } catch (error) {
      console.error("Error fetching enquiries:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.phone || !formData.type || !formData.date) {
      alert("Please fill in all fields.");
      return;
    }

    try {
      if (editingId) {
        await axios.put(`https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/updateEnquiry/${editingId}`, formData);
        alert("Enquiry updated successfully!");
        setEditingId(null);
      } else {
        const response = await axios.post("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/addEnquiry", formData);
        alert(`Enquiry added successfully! Enquiry ID: ${response.data.enquiryId}`);
      }

      resetForm();
      fetchEnquiries();
    } catch (error) {
      console.error("Error submitting enquiry:", error);
      alert("Failed to submit enquiry.");
    }
  };

  const handleEdit = (enquiry) => {
    setEditingId(enquiry.key);
    setFormData({
      name: enquiry.name,
      phone: enquiry.phone,
      type: enquiry.type,
      date: enquiry.date,
    });
  };

  const handleDelete = async (key) => {
    try {
      await axios.delete(`https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/deleteEnquiry/${key}`);
      setEnquiries((prev) => prev.filter((enquiry) => enquiry.key !== key));
      alert("Enquiry deleted successfully!");
    } catch (error) {
      console.error("Error deleting enquiry:", error);
      alert("Failed to delete enquiry.");
    }
  };

  return (
    <div className="container enquiryform">
      <h3 className="text-center">Enquiry Form</h3>
      <form onSubmit={handleSubmit}>
      <div className="row mb-3">
        <div className="col-md-3">
          <label>Name:</label>
          <input
            type="text"
            className="form-control"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="col-md-3">
          <label>Phone Number:</label>
          <input
            type="text"
            className="form-control"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="col-md-3">
          <label>Type:</label>
          <select
            className="form-control"
            name="type"
            value={formData.type}
            onChange={handleInputChange}
            required
          >
            <option value="">Select Type</option>
            <option value="Membership">Membership</option>
            <option value="Single package">Single Package</option>
          </select>
        </div>
        <div className="col-md-3">
          <label>Date:</label>
          <input
            type="date"
            className="form-control"
            name="date"
            value={formData.date}
            onChange={handleInputChange}
            required
          />
        </div>
        </div>
       
        <div className="form-group mt-4">
          <button type="submit" className="btn mr-2">
            Submit
          </button>
          <button type="button" className="btn btn-secondary" onClick={resetForm}>
            Cancel
          </button>
        </div>
      </form>

      <table className="table mt-4">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Enquiry ID</th>
            <th>Name</th>
            <th>Phone</th>
            <th>Type</th>
            <th>Date</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {enquiries.map((enquiry) => (
            <tr key={enquiry.key}>
              <td>{enquiry.sNo}</td>
              <td>{enquiry.enquiryId}</td>
              <td>{enquiry.name}</td>
              <td>{enquiry.phone}</td>
              <td>{enquiry.type}</td>
              <td>{enquiry.date}</td>
              <td>
                <button className="btn btn-warning btn-sm" onClick={() => handleEdit(enquiry)}>
                  Edit
                </button>
              </td>
              <td>
                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(enquiry.key)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EnquiryForm;
